module.exports = __webpack_public_path__ + "media/images/email/rewards/appstore-9026ced3622ce9e1485ec31ec780c56e.png";